import React, { useState } from "react";


import PersonalDetails from "./PersonalDetails";
import ReviewSubmit from "./ReviewSubmit";
import usePassportForm from "./usePassportForm";
import AppointmentStatus from "./AppointmentStatus";
import AddressDetails from "./AddressDetails";
import IdentityDetails from "./IdentityDetails";
import DocumentDetails from "./DocumentDetails";
import ApplicationType from "./ApplicationType";

const steps = [
  "Personal Details",
  "Address Details",
  "Identity Details",
  "Document Details",
  "Application Type",
  "Review & Submit",
];

const PassportApplication = () => {
  const [step, setStep] = useState(0);
  const { formData, updateForm, submitForm, status } = usePassportForm();

  const next = () => setStep(step + 1);
  const prev = () => setStep(step - 1);

  const renderStep = () => {
    switch (step) {
      case 0:
        return <PersonalDetails data={formData} update={updateForm} next={next} />;
      case 1:
        return <AddressDetails data={formData} update={updateForm} next={next} prev={prev} />;
      case 2:
        return <IdentityDetails data={formData} update={updateForm} next={next} prev={prev} />;
      case 3:
        return <DocumentDetails data={formData} update={updateForm} next={next} prev={prev} />;
      case 4:
        return <ApplicationType data={formData} update={updateForm} next={next} prev={prev} />;
      case 5:
        return (
          <ReviewSubmit
            data={formData}
            prev={prev}
            submit={submitForm}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-lg shadow p-6 max-w-5xl mx-auto">

        <h2 className="text-2xl font-semibold mb-6">
          Passport Application
        </h2>

        {/* Steps */}
        <div className="flex justify-between mb-6">
          {steps.map((item, index) => (
            <div
              key={index}
              className={`text-sm ${
                step === index
                  ? "text-blue-600 font-semibold"
                  : "text-gray-400"
              }`}
            >
              {item}
            </div>
          ))}
        </div>

        {renderStep()}

        {status && <AppointmentStatus status={status} />}
      </div>
    </div>
  );
};

export default PassportApplication;